import { LoginVerifyScreen } from "@/features/auth/screens/LoginVerifyScreen";
import { loginVerifyRouteSearchSchema } from "@/features/auth/search/authRouteSearch";
import { createFileRoute } from "@tanstack/react-router";

function LoginVerifyPage() {
    const { phone } = Route.useSearch();
    return <LoginVerifyScreen phone={phone} />;
}

export const Route = createFileRoute("/_auth/_public/login/verify")({
    component: LoginVerifyPage,
    validateSearch: (search) => loginVerifyRouteSearchSchema.parse(search),
});
